// Library imports
import { ReactNode, useEffect, useState } from "react";
import { Canvas } from "@react-three/fiber";

// Mui imports
import { styled } from "@mui/system";

const StyledCanvas = styled(Canvas)(() => ({
  height: "500px",
  width: "100vw",
  // "&:hover": {
  //   cursor: "grab",
  // },
  // "&:active": {
  //   cursor: "grabbing",
  // },
}));

interface IProps {
  children?: ReactNode;
  setClicked: any;
  onPointerDown?: (event: React.PointerEvent) => void;
}

export default function AppCanvas({
  children,
  setClicked,
  onPointerDown,
}: IProps) {
  const [mouseover, setMouseover] = useState(false);
  const [click, setClick] = useState(false);

  useEffect(() => {
    document.body.style.cursor = click ? "grabbing" : "grab";
  }, [click]);

  useEffect(() => {
    document.body.style.cursor = mouseover ? "grab" : "auto";
  }, [mouseover]);

  return (
    <StyledCanvas
      dpr={[1, 1.5]}
      gl={{
        antialias: true,
        powerPreference: "high-performance",
      }}
      onMouseEnter={() => setMouseover(true)}
      onMouseLeave={() => setMouseover(false)}
      onMouseDown={(e: any) => {
        setClick(true);
        if (onPointerDown) onPointerDown(e);
        // setClicked("");
      }}
      onMouseUp={() => setClick(false)}
    >
      <ambientLight />
      {children}
    </StyledCanvas>
  );
}
